import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminRatesScreen from "../../../container/RateAdminScreen/RateAdminRatesScreen";
import CreateRateAdminRates from "../../../container/RateAdminScreen/RateAdminRatesScreen/CreateRateAdminRates";

const RateAdminRatesRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_RATES.HOME}
          element={<RateAdminRatesScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_RATES.CREATE}
          element={<CreateRateAdminRates />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_RATES.EDIT}
          element={<CreateRateAdminRates isEdit={true} />}
        />
      )}
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_RATES.VIEW}
          element={<CreateRateAdminRates isView={true} />}
        />
      )}
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_RATES.COPY}
          element={<CreateRateAdminRates isCopy={true} />}
        />
      )}
    </>
  );
};

export default RateAdminRatesRoutes;
